import { useMemo } from "react";
import styles from "./styles.module.scss";
import { useSelector } from "react-redux";
import WelcomeBox from "../../components/WelcomeBox";
import { selectSigninData } from "../../store/auth/signin/signin.selectors";
import { getUserNames } from "../../shared/utilities";
import Header from "../../components/UI/Header";
import { useViewport } from "../../shared/hooks";

const MainContent = () => {
  const user = useSelector(selectSigninData);
  const { isMobile } = useViewport();

  const names = useMemo(() => {
    return user ? getUserNames(user.name) : { firstName: "", lastName: "" };
  }, [user]);

  return (
    <section className={styles.MainContent}>
      {!isMobile && (
        <div className={styles["MainContent-headerContainer"]}>
          <Header hideSearch />
        </div>
      )}
      <div className={styles["MainContent-wrapper"]}>
        <WelcomeBox isMobile={isMobile} firstName={names.firstName} />
      </div>
    </section>
  );
};

export default MainContent;
